import { Fill, Stroke, Style } from 'es-map-widget';
import { useEffect } from 'react';
import { getDroughtGridStyle, getNormalizedDroughtFilter } from './droughtStyleMap';

export default function DroughtDataprovider({ extent, layerData, setSource }) {
    useEffect(() => {
        if (!layerData.geoms || layerData.geoms.length === 0) {
            setSource(null);
            return;
        }

        const opacity = layerData.opacity || 1;
        const filter = getNormalizedDroughtFilter(layerData.filter);

        setSource(
            layerData.geoms.map((grid) => {
                const isSelected = Boolean(
                    layerData.selectedGridId &&
                        String(grid.grid_id) === String(layerData.selectedGridId)
                );
                const gridStyle = getDroughtGridStyle({ ...grid, isSelected }, filter, opacity);

                return {
                    ...grid,
                    style: new Style({
                        zIndex: gridStyle.zIndex,
                        stroke: new Stroke({
                            color: gridStyle.stroke,
                            width: gridStyle.strokeWidth,
                            lineDash: gridStyle.lineDash,
                        }),
                        fill: new Fill({
                            color: gridStyle.fill,
                        }),
                    }),
                };
            })
        );
    }, [
        extent,
        layerData.filter,
        layerData.geoms,
        layerData.opacity,
        layerData.selectedGridId,
        setSource,
    ]);

    return null;
}
